import {ArrowDownTrayIcon, ArrowUpTrayIcon, TrashIcon} from '@heroicons/react/24/solid';
import React, {useEffect, useState} from 'react';
import {DropzoneOptions, useDropzone} from 'react-dropzone';
import {Button} from '../button';
import toast from "react-hot-toast";
import ExcelIcon from "@/routes/org/event/slug/ots/payments/_assets/excel.png"
import FileIcon from "@/routes/org/event/slug/ots/payments/_assets/folder.png"

interface DropzoneProps
    extends Pick<DropzoneOptions,
        'accept' | 'minSize' | 'maxSize' | 'maxFiles' | 'disabled'> {
    onChange: (files: File[]) => void;
    onDelete?: () => void;
    previewUrl?: string
    type?: string
    mimeType?: string
    maxSizeMb?: number
    templateUrl?: string
}

export const Dropzone: React.FC<DropzoneProps> = ({
                                                      onChange,
                                                      onDelete,
                                                      previewUrl = '',
                                                      type = 'Gambar',
                                                      mimeType = 'JPG, JPEG, PNG',
                                                      maxSizeMb = 2,
                                                      templateUrl,
                                                      ...props
                                                  }) => {
    const defaultImages: any = previewUrl ? [previewUrl] : [];
    const [previewFileUrls, setPreviewFileUrls] = useState<string[]>(defaultImages);

    useEffect(() => {
        setPreviewFileUrls(defaultImages)
    }, [previewUrl])

    let mimeTypes;
    if(mimeType === "XLSX") {
        mimeTypes = {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
        };
    } else {
        mimeTypes = {
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/png': ['.png'],
        };
    }

    const {acceptedFiles, open, getRootProps, getInputProps} = useDropzone({
        ...props,
        accept: mimeTypes,
        maxSize: maxSizeMb * 1024 * 1024,
        onDrop: (acceptedFiles, rejectedFiles) => {
            if (rejectedFiles.length > 0) {
                rejectedFiles.forEach((file) => {
                    file.errors.forEach((err) => {
                        if (err.code === 'file-too-large') {
                            toast.error(`File terlalu besar, maksimal ${maxSizeMb}MB`);
                        } else if (err.code === 'file-invalid-type') {
                            toast.error("Tipe file salah, hanya boleh jpg/jpeg & png");
                        }
                    });
                });
            }

            if (acceptedFiles.length > 0) {
                const newUrls = acceptedFiles.map((file) => {
                    if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
                        return URL.createObjectURL(file)
                    } else if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                        return ExcelIcon;
                    } else {
                        return FileIcon;
                    }
                })

                setPreviewFileUrls(newUrls);
                onChange(acceptedFiles);
            }
        },
    });

    const thumbs = previewFileUrls.map((url) => {
        return (
            <img
                className='h-[80px] max-w-full rounded-md object-cover'
                src={url}
                alt=''
            />
        );
    });

    const removeFile = (event: any) => {
        previewFileUrls.forEach((url) => URL.revokeObjectURL(url));

        setPreviewFileUrls([]);
        event.stopPropagation();

        if (onDelete) {
            onDelete();
        }
    };

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => previewFileUrls.forEach((url) => URL.revokeObjectURL(url));
    }, []);

    return (
        <div
            {...getRootProps({
                className:
                    'flex flex-col items-center gap-4 rounded-md border-[1px] border-neutral-40 bg-neutral-20 p-4',
            })}
        >
            <input {...getInputProps()} />
            {thumbs}
            <p className='text-xs text-neutral-70'>
                Maksimal ukuran file {maxSizeMb}MB & Maksimal {props.maxFiles} file (Format: {mimeType})
            </p>
            <div className='flex gap-3'>
                {previewFileUrls.length > 0 && <Button
                    size='sm'
                    variant='danger'
                    look='outline'
                    element='button'
                    onClick={removeFile}
                    leftIcon={<TrashIcon/>}
                >
                    Hapus {type}
                </Button>}
                {previewFileUrls.length === 0 &&
                    <div className={'flex gap-2'}>
                        <Button
                            size='sm'
                            element='button'
                            onClick={(event) => {
                                event.stopPropagation();
                                open();
                            }}
                            leftIcon={<ArrowUpTrayIcon/>}
                        >
                            Unggah {type}
                        </Button>
                        {templateUrl && <Button
                            variant={'neutral'}
                            size='sm'
                            element='button'
                            onClick={(event) => {
                                event.stopPropagation();
                                open();
                            }}
                            leftIcon={<ArrowDownTrayIcon/>}
                        >
                            Download Template
                        </Button>}
                    </div>}
            </div>
        </div>
    );
};
